import { render, staticRenderFns } from "./Elecocite.vue?vue&type=template&id=9f63ee94"
import script from "./Elecocite.vue?vue&type=script&lang=js"
export * from "./Elecocite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports